<template lang="pug">
  v-dialog(v-model="show", persistent, max-width="50%")
      v-card(v-if="fatura")
          v-card-title
            v-flex.md8.title Incentivos do Bigou
            v-flex.md4.text-xs-right
              v-btn(flat, @click="close()", density="comfortable", icon="", variant="plain")
                v-icon close
          v-card-text
              template
                  h4.pt-3(style="font-size: 18px; color:#1113128A; font-weight:500") Cálculo do total de incentivos
                  div(style="background-color:#FAFAFA; border-radius:8px").pa-3.mt-4.mb-4
                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label Reembolso dos cupons de desconto usados em <strong> {{' ' + (fatura.indicadores ? fatura.indicadores.quantidadeDescontosPgtOnline : 0)}} vendas com pagamento online</strong>
                            br
                            small(style="font-size:16px; color:#1113128A") (cupons do Bigou)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{ (fatura.indicadores ? fatura.indicadores.totalDescontosPgtOnline : 0) | currency }}

                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label Reembolso dos <strong>subsídios</strong> usados em
                                strong {{ ' ' + (fatura.indicadores ? fatura.indicadores.quantidadeReembolsosPromocionaisPgtOnline : 0) }} vendas com pagamento online
                            br
                            small(style="font-size:16px; color:#1113128A") (promoções com subsídio)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{ (fatura.indicadores ? fatura.indicadores.totalReembolsosPromocionaisPgtOnline : 0) | currency }}
                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label Reembolso dos <strong>cupons de desconto</strong> usados em <strong> {{' ' + (fatura.indicadores ? fatura.indicadores.quantidadeDescontosOffline : 0)}} vendas com pagamento em dinheiro ou maquininha de cartão</strong>
                            br
                            small(style="font-size:16px; color:#1113128A") (cupons do Bigou)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{ (fatura.indicadores ? fatura.indicadores.totalDescontosOffline : 0) | currency }}
                    v-layout(row, wrap).pb-4
                        v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                            label Reembolso dos <strong>subsídios</strong> usados em
                                strong {{' ' + (fatura.indicadores ? fatura.indicadores.quantidadeReembolsosPromocionaisOffline : 0)}} vendas com pagamento em dinheiro ou maquininha de cartão
                            br
                            small(style="font-size:16px; color:#1113128A") (promoções com subsídio)
                        v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                            strong + {{ (fatura.indicadores ? fatura.indicadores.totalReembolsosPromocionaisOffline : 0) | currency }}
                  div(style="border:1px solid; border-radius:8px; color:#0000000A").pa-3.mt-4.mb-4
                      v-layout(row, wrap)
                          v-flex.md6.xs12(style="font-size:18px; color:#111312")
                              strong Total de incentivos em {{(fatura.indicadores ? fatura.indicadores.quantidadeReembolsosPromocionais + fatura.indicadores.quantidadeDescontos : 0)}} vendas
                          v-flex.md6.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                              strong {{ (fatura.indicadores ? fatura.indicadores.totalReembolsosPromocionais + fatura.indicadores.totalDescontos : 0) | currency }}
  
          v-card-actions.mr-4.pb-3
              v-spacer
              v-btn(flat,@click="close()") Fechar
  
  </template>
  
  <script>
  
  export default {
    props: {
    },
    data () {
      return {
          show : false,
          fatura : null
      }
    },
    created () {
  
    },
    watch: {
    },
    computed: {
    },
    methods: {
      open(fatura){
        const vm = this;
        vm.fatura = fatura;
        vm.show = true;
      },
      close(){
          const vm = this;
          vm.fatura = null;
          vm.show = false;
      }
    }
  }
  </script>
  